import moment from 'moment'


export default function FormattedDate(date) {
    return date ? moment(date).format("DD-MM-YYYY") : ''
}